export default __webpack_public_path__ + "static/media/1.07a1668b.png";